import { startTransition, useEffect, useMemo, useState } from 'react';

/** Start a media query listener. The listener can be created conditionally based on the optional enabled prop. */
export const useMatchMedia = (mediaQuery: string, enabled = true) => {
  const mediaQueryList = useMemo(
    // window.matchMedia is undefined in tests.
    () => (enabled ? (window.matchMedia?.(mediaQuery) as MediaQueryList | undefined) : undefined),
    [enabled, mediaQuery]
  );
  const [match, setMatch] = useState<boolean>(!!mediaQueryList?.matches);

  useEffect(() => {
    // The state initializer only runs on first render, so sync when `enabled` or `mediaQuery` changes the media query list.
    setMatch(!!mediaQueryList?.matches);
    if (mediaQueryList) {
      const callback = (e: MediaQueryListEvent) => {
        startTransition(() => setMatch(e.matches));
      };

      mediaQueryList.addEventListener('change', callback);
      return () => {
        mediaQueryList.removeEventListener('change', callback);
      };
    }
  }, [mediaQueryList]);
  return match;
};
